import { FC } from "react";
import { Navigation, Section } from "../../../@component/layout";
import { Button } from "../../../@component/buttons";
import { Banner } from "../../../@component/sections/banner";
import { About } from "../../../@component/sections/about";
import { Program } from "../../../@component/sections/program";
import { Impact } from "../../../@component/sections/impact";
import { Location } from "../../../@component/sections/locations";
import { Faqs } from "../../../@component/sections/faq";
import { Footer } from "../../../@component/layout/footer";
import { AboutFounder } from "../../../@component/sections/about-founder";
import { Icons } from "../../../@component/icons";
import { faUncharted } from "@fortawesome/free-brands-svg-icons";
import { ProgramInfo } from "../../../@component/sections/program-info";
import { Images } from "../../../@assets/images";
import { Timeline } from "../../../@component/sections/timeline";
import { NormalText } from "../../../@component/sections/normal-text";
import { Process } from "../../../@component/sections/process";
import { Loop, Interview, Pengumuman, Scrin, Scrining } from "./icons";
import { Benefit } from "../../../@component/sections/benefit";
import { Gallery } from "../../../@component/sections/gallery";
import { Criteria } from "../../../@component/sections/criteria";
import { ContactUsLite } from "../../../@component/sections/contact-us-lite";

export const Accelerate: FC = (props) => {
  return (
    <Section>
      <Navigation>
        <Button>hallo</Button>
      </Navigation>
      <Banner
        link={{
          create: "https://s.id/Reg-BEKUP-Growth",
          eplore: "/s/program",
        }}
        hashTag={"#BEKUPACCELERATE"}
        img={Images.design.maleFemale}
        title="Ingin Tingkatkan Inovasi Startupmu?"
        subTitle="Kami akan bantu kamu menjembatani kesenjangan pendanaan yang sering jadi kendala startup. Program ini dirancang khusus untuk mengembangkan kamu sebagai founder secara menyeluruh, memadukan kemampuan bisnis yang kuat dengan keahlian pengembangan produk yang mumpuni."
      />

      <Timeline title="Timeline BEKUP Accelerate" image={Images.design.timeLineAcelerate} />
      <Criteria link="https://s.id/Reg-BEKUP-Growth" />
      <Process
        data={[
          { icon: <Loop />, text: "Open Call" },
          { icon: <Scrining />, text: "Screening Dokumen" },
          { icon: <Scrin />, text: "SCRIN" },
          { icon: <Interview />, text: "Sesi Interview" },
          { icon: <Pengumuman />, text: "Pengumuman" },
        ]}
      />
      <Benefit />
      <Gallery link="https://s.id/Reg-BEKUP-Growth" images={Images.design.gallery} />
      <ContactUsLite />
      <Footer />
    </Section>
  );
};
